import { Controller, useFormContext } from "react-hook-form";
import { Flex } from "../../../../../components/Flex";
import { Text } from "../../../../../components/Text";
import { useTranslation } from "react-i18next";
import { TestIDs } from "../../../../../tests/types/testIds";
import { Textarea } from "../../../../../components/Textarea";
import { Lengths } from "../../../../../model/shared/enum/Lengths.enum";
import { Input } from "../../../../../components/Input";
import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { Spacing } from "../../../../../theme/Spacing";
import styled from "styled-components";
import { useCallback } from "react";
import { useStepperRegisterValidation } from "../../../../../components/stepper/useStepperRegisterValidation";
import { useStepContext } from "../../../../../components/stepper/StepperContext";

const Container = styled(Flex)`
  gap: ${Spacing.xl};
  width: 50%;
  flex-wrap: wrap;
  align-self: flex-start;
  flex-direction: column;
`;

export const SettingsAIChatBotStepBasicInfo = () => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const { currentStep } = useStepContext();

  const canGoNext = useCallback(() => {
    return true;
  }, []);

  useStepperRegisterValidation(currentStep, canGoNext);

  return (
    <Container>
      <Flex alignItems="center" gap="s">
        <AtiraIcon icon={faUser} color="main" size="xl" />

        <Text fontSize="l" fontWeight={"bold"} color="main">
          {t("settings.aiChatbot.sections.info.title")}
        </Text>
      </Flex>

      <Controller
        name="name"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Flex flexDirection="column" gap="s">
            <Input
              value={value}
              onChange={onChange}
              title={t("settings.aiChatbot.name.input.title")}
              placeholder={t("settings.aiChatbot.name.input.placeholder")}
              info={t("settings.aiChatbot.name.input.info")}
              valid={!error?.message}
              errorMessage={error?.message}
              maxLength={Lengths.DESCRIPTION}
              dataTestId={TestIDs.chatbot.drawer.createEdit.fields.name}
            />
          </Flex>
        )}
      />

      <Controller
        name="description"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Textarea
            value={value}
            onChange={onChange}
            title={t("settings.aiChatbot.description.input.title")}
            placeholder={t("settings.aiChatbot.description.input.placeholder")}
            info={t("settings.aiChatbot.description.input.info")}
            valid={!error?.message}
            errorMessage={error?.message}
            maxLength={Lengths.LONG}
            dataTestId={TestIDs.chatbot.drawer.createEdit.fields.description}
          />
        )}
      />

      <Controller
        name="config.textBoxPlaceholder"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Input
            onChange={onChange}
            value={value}
            dataTestId={
              TestIDs.chatbot.drawer.createEdit.fields.textBoxPlaceholder
            }
            placeholder={t("settings.aiChatbot.config.placeholder.placeholder")}
            title={t("settings.aiChatbot.config.placeholder.title")}
            info={t("settings.aiChatbot.config.placeholder.info")}
            valid={!error}
            errorMessage={error?.message}
          />
        )}
      />
    </Container>
  );
};
